import React from 'react';
import { Text, Whitespace } from '../common';

export default props => {
  const { stepNumber, headerText, instructions } = props;
  return (
    <div>
      <Text
        fontSize="5xl"
        thin
        primaryDark
        noclip
        letterSpacing="-.5px"
        style={{
          lineHeight: '48px',
        }}
      >
        {headerText}
      </Text>
      {instructions && (
        <div>
          <Whitespace />
          <Text grayDark noclip>
            {instructions}
          </Text>
          <Whitespace />
        </div>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components_new/addListing/StepHeaderBlock.js